import { Card, Row, Col, Button } from '@themesberg/react-bootstrap'
import React, { useState } from 'react'
import { ExclamationCircleOutlined, InboxOutlined } from '@ant-design/icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSetRecoilState } from 'recoil';
import { Form, Input, Upload, Button as AntButton, Modal } from 'antd';
import { dummyRequest } from '../../../services/utilities';
import { activateBlog, deleteBlog, updateBlogs } from '../../../services/apiCalls';
import { faEdit, faExclamation, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { blogAlert, blogResponse, blogRefresh, createBlogModal } from '../../../states/blogs';
import { useHistory } from 'react-router-dom';

const BlogCardHome = ({ img, description, status, link, name, link_url, title, type, id, index }) => {
  const [loading, setLoading] = useState(false)
  const [file, setFile] = useState()
  const [createModal, setCreateModal] = useState(false)
  const setShowAlert = useSetRecoilState(blogAlert);
  const setResponse = useSetRecoilState(blogResponse)
  const setRefresh = useSetRecoilState(blogRefresh)
  const [form] = Form.useForm()
  const history = useHistory()
  const { confirm } = Modal;
  const onFinish = async (val) => {
    setLoading(true)
    const date = new Date()
    try {
      const res = await updateBlogs({ data: val, id })
      if (res.status) {
        setResponse({ message: res.message, title: "success" })
        setShowAlert(true)
        setRefresh(date.toTimeString())
        setCreateModal(false)
        setFile()
      } else {
        setResponse({ message: res.message || res, title: "failed" })
        setShowAlert(true)
        setFile()
      }
    } catch (error) {
      console.log(error)
    }
    setLoading(false)
    setFile()
  }

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  const handleChange = info => {
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, imageUrl => {
        setFile(info.file.originFileObj)
      });
    }
  };

  const offVul = (id) => {
    const data = {status: 0}
    console.log(id)
    confirm({
      title: `Are you sure you want to activate ${name}?`,
      icon: <FontAwesomeIcon icon={faExclamation} color="primary" />,
      content: 'Click Ok to continue',
      onOk() {
        handleShowHide(id, data)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const onVul = (id) => {
    const data = {status: 1}
    console.log(id)
    confirm({
      title: `Are you sure you want to activate ${name}?`,
      icon: <FontAwesomeIcon icon={faExclamation} color="primary" />,
      content: 'Click Ok to continue',
      onOk() {
        handleShowHide(id, data)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const handleShowHide = async (id, status) => {
    const date = new Date()
    console.log(status, id)
    const res = await activateBlog({ data: status, id })
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
  }

  const confirmDelete = (id) => {
    confirm({
      title: `Are you sure you want to delete ${name}?`,
      icon: <ExclamationCircleOutlined />,
      content: 'Click Ok to continue',
      onOk() {
        handleDelete(id)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const handleDelete = async (id) => {
    const date = new Date()
    const res = await deleteBlog(id)
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
  }
  const setShowModal = useSetRecoilState(createBlogModal);

  return (
    <>
      <Card border="light" className="bg-white shadow-sm mb-4">
        <Card.Body>
          {name === "top" ?
            <div>
              <h4 dangerouslySetInnerHTML={{ __html: title }} />
              <p dangerouslySetInnerHTML={{ __html: description }} />
              {/* <Button size="sm" variant="primary" className="text-white me-2" onClick={() => confirmDelete(id)}>
                <FontAwesomeIcon icon={faTrash} />
              </Button> */}
            </div>:
            <div>
              <div className="table-settings mb-2">
                <Button 
                  variant="success" 
                  className="text-white
                  me-3"
                  onClick={() => history.push({ pathname: `/blog-lists/${id}`, state: {title, description}})}
                >
                    View Posts
                </Button>
              </div>
              <h5>{title}</h5>
              <p>{description}</p>
              <Button variant="success" size="sm" className="text-white me-2" onClick={() => setCreateModal(true)}>
                <FontAwesomeIcon icon={faEdit} />
              </Button>
              <Button size="sm" variant="primary" className="text-white me-2" onClick={() => confirmDelete(id)}>
                <FontAwesomeIcon icon={faTrash} />
              </Button>
              {status === 1 ?
                <Button variant="primary" size="sm" className="text-white me-2" onClick={()=>offVul(id)}>
                  Deactivate
                </Button>:
                <Button variant="secondary" size="sm" className="text-white me-2" onClick={()=>onVul(id)}>
                  Activate
                </Button>
              }
            </div>
          }
        </Card.Body>
      </Card>
      {/*update merchant hero start */}
      <Modal
        title="Update Blog Top Content "
        centered
        open={createModal}
        footer={null}
        onCancel={() => setCreateModal(false)}
      >
        <Form form={form} onFinish={onFinish} layout="vertical" initialValues={{ title, link_url, description, image_url: img }}>
          <Form.Item label="Title" name="title" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item label="Description" name="description" rules={[{ required: true }]}>
            <Input.TextArea />
          </Form.Item>
          <Form.Item>
            <AntButton type="primary" htmlType="submit" loading={loading}>
              Update
            </AntButton>
          </Form.Item>
        </Form>
      </Modal>
      {/**update merchant hero end */}
    </>
  )
}

export default BlogCardHome
